import { Modal as AntModal } from 'antd';
import styled from 'styled-components';

export const Modal = styled(AntModal)`
  width: 80% !important;
  max-width: 900px;

  .ant-modal-body {
    padding: 0;
    width: auto;
  }
`;

export const ModalContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
